import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

class SingleBarChart extends React.Component {
  constructor(props) {
    super(props);
    this.singleBarChart = React.createRef();
  }

  render() {
    let props = this.props;
    let BarChart;
    let percentage;

    if (props.isInvalid) {
      BarChart = BarChartInvalid;
      percentage = 0;
    } else {
      BarChart = BarChartBackground;
      percentage = props.percentage;
    }

    return (
      <BarChart isInvalid={props.isInvalid} percentage={percentage} ref={this.singleBarChart}>
        <BarChartFill percentage={percentage} />
      </BarChart>
    );
  }
}

SingleBarChart.propTypes = {
  isInvalid: PropTypes.bool,
  percentage: PropTypes.number,
};

const barChartBase = css`
  border: none;
  height: 16px;
  }
`;

export const BarChartBackground = styled.div`
  ${barChartBase};
  background: #c6d0d9;
  border-radius: 8px;
  overflow: hidden;
  display: inline-block;
  margin: 3px 8px 0px;
  position: relative;
  width: 68px;
`;

export const BarChartFill = styled.div`
  ${barChartBase};
  background: #2a5275;
  height: 100%;
  transition: width 0.2s ease-in;
  width: ${p => p.percentage}%;
  max-width: 100%;
`;

export const BarChartInvalid = styled.div`
  ${barChartBase};
  background: ${p => p.theme.colors.gray300};
  border-radius: 8px;
  display: inline-block;
  margin: 3px 8px 0px;
  position: relative;
  width: 68px;
`;

export default SingleBarChart;
